export default __webpack_public_path__ + "static/media/gallery_00.7d25de5b.jpg";